import { render, staticRenderFns } from "./regHeader.vue?vue&type=template&id=78483889&"
import script from "./regHeader.vue?vue&type=script&lang=js&"
export * from "./regHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports